module.exports = __webpack_public_path__ + "img/BX0.60f87019.png";